import React from 'react';

import CNN from './svgs/cnn.inline.svg';
import FoxSports from './svgs/fox-sports.inline.svg';
import GMA from './svgs/gma.inline.svg';
import KTLA from './svgs/ktla5.inline.svg';
import NPR from './svgs/npr.inline.svg';
import NYT from './svgs/nyt.inline.svg';
import People from './svgs/people.inline.svg';
import UsWeekly from './svgs/us-weekly.inline.svg';
import VanityFair from './svgs/vanity-fair.inline.svg';
import WSJ from './svgs/wsj.inline.svg';

export const Logos: React.ReactNode[] = [
	<KTLA key='ktla' />,
	<GMA key='gma' />,
	<NPR key='npr' />,
	<WSJ key='wsj' />,
	<NYT key='nyt' />,
	<CNN key='cnn' />,
	<VanityFair key='vf' />,
	<UsWeekly key='uw' />,
	<FoxSports key='fox' />,
	<People key='people' />,
];
